import React from 'react'
import MediaQuery from 'react-responsive'

import { AcornsIcon } from '@acorns/icons'
import { ActionStrip } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'

import ActionStripMobile from 'components/ActionStripMobile'
import Nav from 'components/Nav'
import theme from 'theme'

import { CryptoInterstitalProps, STRING_PREFIX, ValueProp } from './CryptoInterstitial'
import { MobileButton } from './MobileButton'
import {
  Body,
  BodyHeader,
  Container,
  MarkdownStyler,
  MobileButtonContainer,
  StyledAddPortfolioButton,
  StyledLogo,
  StyledMarkdown,
  TextContainer,
  Title,
  ValuePropContainer,
} from './styled-components'

export const CryptoLanderContent: React.FC<CryptoInterstitalProps> = ({
  onBack,
  cta,
  header1,
  header2,
  icons,
  imageUrl,
  title,
  value_prop1,
  value_prop2,
  value_prop3,
  action_strip_title,
  ...props
}) => {
  const { StyledRemoteString } = useRemoteStrings()

  return (
    <>
      <MediaQuery minWidth={theme.breakpoints.sm + 1}>
        <ActionStrip verticalSubText maxWidth={800} title={action_strip_title} onBack={onBack} />
        <Nav hideProgressBar={true} />
      </MediaQuery>
      <Container>
        <MediaQuery maxWidth={theme.breakpoints.sm}>
          <ActionStripMobile
            backgroundColor={theme.colors.greenDark}
            closeButton={AcornsIcon.Icon.CloseXIconWhite}
            handleBackPress={onBack}
            handleClosePress={onBack}
            showCloseIcon={true}
          />
        </MediaQuery>
        <StyledLogo src={imageUrl} />
        <TextContainer>
          <Title>{title}</Title>
          <ValuePropContainer>
            {[value_prop1, value_prop2, value_prop3].map((prop, index) => (
              <ValueProp iconName={icons[index]} copy={prop} key={`${prop}${index}`} />
            ))}
          </ValuePropContainer>
          <MediaQuery minWidth={theme.breakpoints.sm + 1}>
            <StyledAddPortfolioButton onPress={props.onAddPortfolioPress} secondary>
              {cta}
            </StyledAddPortfolioButton>
          </MediaQuery>
          <BodyHeader>{header1}</BodyHeader>
          <Body>
            <StyledRemoteString stringKey={`${STRING_PREFIX}body1`} modifiers={[{ bold: 600 }]} />
          </Body>
          <BodyHeader>{header2}</BodyHeader>
          <Body>
            <StyledRemoteString
              stringKey={`${STRING_PREFIX}body2.markdown`}
              modifiers={[
                { bold: 600 },
                { bold: 600 },
                { bold: 600 },
                { bold: 600 },
                { bold: 600 },
              ]}
              wrappers={[
                MarkdownStyler,
                MarkdownStyler,
                MarkdownStyler,
                MarkdownStyler,
                MarkdownStyler,
              ]}
            />
            <StyledMarkdown
              source={props['disclosure.link.markdown']}
              linkTarget={'_blank'}
              escapeHtml={false}
            />
          </Body>
          <MediaQuery maxWidth={theme.breakpoints.sm}>
            <MobileButtonContainer>
              <MobileButton
                text={cta}
                onPress={props.onAddPortfolioPress}
                secondary
                backgroundColor={theme.colors.greenDark}
              />
            </MobileButtonContainer>
          </MediaQuery>
        </TextContainer>
      </Container>
    </>
  )
}
